// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"u1-z"};